document.addEventListener('DOMContentLoaded', function () {
    // ========== 数量角标配置 ==========
    const PACK_COUNT_BADGE_VALUES = ["1", "2"];  // 对应尺寸选项的显示值
    const PACK_COUNT_BADGE_GROUP_INDEX = 1;      // 尺寸选项组索引（第二个选项组）

    // 获取当前活跃的变体按钮索引
    function getActiveVariantButtonIndex(group) {
        if (!group) return 0;
        const buttons = Array.from(group.querySelectorAll(".sp-option"));
        const activeIndex = buttons.findIndex(button => 
            button.classList.contains("active")
        );
        return activeIndex >= 0 ? activeIndex : 0;
    }

    // 更新数量角标显示
    function updatePackCountBadge() {
        const packCountBadge = document.querySelector(".js-pack-count-badge");
        if (!packCountBadge) return;

        // 获取尺寸选项组
        const sizeGroup = document.querySelector("#sp-size");
        if (!sizeGroup) return;

        // 获取当前选中的尺寸索引
        const selectedIndex = getActiveVariantButtonIndex(sizeGroup);
        
        // 根据索引显示对应的值
        packCountBadge.textContent = PACK_COUNT_BADGE_VALUES[selectedIndex] || PACK_COUNT_BADGE_VALUES[0] || "";
        
        console.log('角标更新:', { selectedIndex, value: packCountBadge.textContent });
    }

    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min
    }

    let endTimeG

    function cutDownTime() {
        let nowTime = new Date()
        let endTime = new Date(endTimeG)

        let leftTime = endTime.getTime() - nowTime.getTime()
        if (leftTime < 0) {
            setupNewCountdown()
            leftTime = 0
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60)
        leftH = leftH >= 10 ? leftH : '0' + leftH
        leftM = leftM >= 10 ? leftM : '0' + leftM
        leftS = leftS >= 10 ? leftS : '0' + leftS

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        }
    }

    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9)
        const currentTime = new Date()
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
    }

    let intervalId

    function getCutDownTime() {
        setupNewCountdown()
        if (intervalId) clearInterval(intervalId)
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime()
            $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
            $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
            $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
        }, 1000)
    }

    getCutDownTime()

    let spImgList = [
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1751453316238.jpg?v=1773816459&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/spp_20250714103750_8ac138971a0be1910b40fddc2d55dedc_855c98c9-5a74-4ab8-8477-35c121cc7af3.jpg?v=1773816545&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/spp_20250714103750_17f2f434740b0684fb2eaebd91a08b1e_398356d7-0abe-4816-bdcf-87827a68c783.jpg?v=1773816545&width=1946',
        "https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1751453313268.jpg?v=1773816721",
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1751453310042.jpg?v=1773816737&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1751453316238.jpg?v=1773816459&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/spp_20250714103750_8ac138971a0be1910b40fddc2d55dedc_855c98c9-5a74-4ab8-8477-35c121cc7af3.jpg?v=1773816545&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/spp_20250714103750_17f2f434740b0684fb2eaebd91a08b1e_398356d7-0abe-4816-bdcf-87827a68c783.jpg?v=1773816545&width=1946',
        "https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1751453313268.jpg?v=1773816721",
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1751453310042.jpg?v=1773816737&width=1946',
        "https://cdn.shopify.com/s/files/1/0669/2952/4932/files/3_b827988b-5be4-47d0-a1af-1ad234bd66d9.png?v=1780475279&width=1946",
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/2_ad7a486c-6443-42f9-b190-58b71012dcc8.png?v=1780475279&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1_42c66b2a-c753-454f-a078-f4b6ba47e00c.png?v=1780475279&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/5_2a1edafb-8e1e-4e96-b445-e5fed558a30a.png?v=1780475280&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/4_67b85a44-f0cd-4f56-86a3-2def5197630a.png?v=1780475279&width=1946',
        "https://cdn.shopify.com/s/files/1/0669/2952/4932/files/3_b827988b-5be4-47d0-a1af-1ad234bd66d9.png?v=1780475279&width=1946",
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/2_ad7a486c-6443-42f9-b190-58b71012dcc8.png?v=1780475279&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/1_42c66b2a-c753-454f-a078-f4b6ba47e00c.png?v=1780475279&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/5_2a1edafb-8e1e-4e96-b445-e5fed558a30a.png?v=1780475280&width=1946',
        'https://cdn.shopify.com/s/files/1/0669/2952/4932/files/4_67b85a44-f0cd-4f56-86a3-2def5197630a.png?v=1780475279&width=1946',
    ]

    function mainRender() {
        $(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)

            window.addEventListener(
                'resize',
                (function () {
                    var timer
                    return function () {
                        if (timer) clearTimeout(timer)
                        timer = setTimeout(function () {
                            $('#root').css('zoom', 'normal')
                            let scale = document.body.clientWidth / 1080
                            $('#root').css('zoom', scale)
                        }, 100)
                    }
                })()
            )
        })

        function lazyLoadImages() {
            const images = document.querySelectorAll('.lazy-load')
            const config = {
                rootMargin: '0px 0px 1300px 0px',
                threshold: 0,
            }

            const lazyLoadObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        const image = entry.target
                        const dataSrc = image.getAttribute('data-src')
                        if (dataSrc) {
                            image.src = dataSrc
                        }
                        lazyLoadObserver.unobserve(image)
                    }
                })
            }, config)

            images.forEach(function (image) {
                lazyLoadObserver.observe(image)
            })
        }

        function preloadImages(imageArray) {
            if (Array.isArray(imageArray[0])) {
                imageArray.forEach(subArray => {
                    subArray.forEach(url => {
                        const img = new Image()
                        img.src = url
                    })
                })
            } else {
                imageArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            }
        }

        lazyLoadImages()
        preloadImages(spImgList)

        // 跳转套餐锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault()
                const targetElement = document.getElementById('shopping')
                if (targetElement) {
                    const offsetTop = targetElement.offsetTop
                    let _topHeight = $('.time-part').height() + $('.sp-header-top').height() - 10
                    window.scroll({
                        top: offsetTop * $('div#root').css('zoom') - _topHeight * $('div#root').css('zoom'),
                        behavior: 'smooth',
                    })
                }
            })
        })

        // IOS字体间距处理
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        var isAndroid = /android/i.test(userAgent)
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent)

        if (isIOS) {
            console.log('iOS')
        } else if (isAndroid) {
            console.log('Android')
        } else if (isPC) {
            console.log('PC')
        } else {
            $('.sp_system').css('letter-spacing', '-4px')
        }
    }

    mainRender()

    // ========== 商品相关逻辑 ==========
    let prods = window.product || []

    // 获取当前选中的变体
    function getCur() {
        if (!prods.length) return null
        
        let color = $('#sp-color .sp-option.active').attr('data-value')
        // let size = $('#sp-size .sp-option.active').attr('data-value')
        // let addon = $('#sp-add .sp-option.active').attr('data-value')
        
        // 匹配变体
        let variant = prods.find(item => {
            return item.option1 == color
        })
        
        return variant
    }

    // 更新价格显示
    function changePrice() {
        let curVariant = getCur()
        if (!curVariant) {
            console.log('未找到匹配的变体')
            return
        }
        
        let num = parseInt($('#calcNumber').val()) || 1
        if (num < 1) num = 1
        
        let price = (curVariant.price * num / 100).toFixed(2)
        let compare = (curVariant.compare_at_price * num / 100).toFixed(2)
        
        price = price.replace('.', ',')
        compare = compare.replace('.', ',')
        
        $('#sp_price1').html(price)
        $('#sp_price2').html(compare)
        
        let offPercent = 0
        if (curVariant.compare_at_price && curVariant.compare_at_price > curVariant.price) {
            offPercent = 100 - Math.ceil(curVariant.price / curVariant.compare_at_price * 100)
        }
        $('.product-part .sp-off').html(offPercent)
    }

    // ========== 数量加减 ==========
    $('.sp-reduce').click(function () {
        let input = $('#calcNumber')[0]
        if (input) {
            let num = parseInt(input.value) - 1
            if (num >= 1) {
                input.value = num
                changePrice()
            }
        }
    })

    $('.sp-add').click(function () {
        let input = $('#calcNumber')[0]
        if (input) {
            let num = parseInt(input.value) + 1
            input.value = num
            changePrice()
        }
    })

    $('#calcNumber').on('input', function () {
        let num = parseInt(this.value) || 1
        if (num < 1) this.value = 1
        changePrice()
    })

    // 计算图片索引
    function getImageIndex() {
        let colorIndex = $('#sp-color .sp-option.active').index();
        // let sizeIndex = $('#sp-size .sp-option.active').index();
        // let addIndex = $('#sp-add .sp-option.active').index();
        // 颜色5种，尺寸2种，附加2种 → 权重：尺寸×5，附加×10
        return colorIndex;
    }

    // 更新主图
    function updateMainImage() {
        let imgIndex = getImageIndex();
        console.log("图片索引:", imgIndex);
        
        if (spImgList[imgIndex]) {
            $('.product-part .sp-img-p').attr('src', spImgList[imgIndex]);
        } else {
            console.warn('图片索引超出范围:', imgIndex);
        }
    }

    // ========== 选项点击事件 ==========
    $('#sp-color .sp-option').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        updateMainImage();
        updateProductNumBadge();
        // updatePackCountBadge();  // 更新角标
        changePrice();
    })

    $('#sp-size .sp-option').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        updateMainImage();
        updateProductNumBadge();
        // updatePackCountBadge();  // 更新角标
        changePrice();
    })

    $('#sp-add .sp-option').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        updateMainImage();
        changePrice();
    })

    // 更新数量角标（根据尺寸显示 x2/x4）
    function updateProductNumBadge() {
        let sizeIndex = $('#sp-size .sp-option.active').index();
        if (sizeIndex == 1) {
            $('.product_num').text('x2');
        } else if (sizeIndex == 2) {
            $('.product_num').text('x4');
        } else {
            $('.product_num').text('');
        }
    }

    // ========== 购买按钮 ==========
    $('.emitCheckout').click(function () {
        let num = $('#calcNumber').val() || 1
        let curVariant = getCur()
        if (curVariant && curVariant.id) {
            window.location.href = "/cart/" + curVariant.id + ":" + num
        } else {
            console.log('无法获取变体ID')
        }
    })

    // ========== 购物车加购 ==========
    $('.cart-btn').click(function () {
        $(this).children('img').addClass('on')
        setTimeout(function () {
            $('.cart-btn').children('img').removeClass('on')
        }, 500)

        let spNum = $('#calcNumber').val() || 1
        let curVariant = getCur()
        
        if (curVariant && curVariant.id) {
            var data = {
                id: curVariant.id,
                quantity: parseInt(spNum),
            }
            
            console.log('添加购物车:', data)
            
            if (typeof $ !== 'undefined' && $.ajax) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: data,
                    success: function () {
                        console.log('添加成功')
                        if (window.Shopify && window.Shopify.routes) {
                            $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                                $('#cardNum').html(result.item_count)
                                $('#cardNum').removeClass('sp-gray')
                            })
                        }
                    },
                    error: function(xhr, status, error) {
                        console.log('添加失败:', error)
                    },
                    dataType: 'json',
                })
            }
        } else {
            console.log('无法获取变体ID，请检查选项配置')
        }

        // 飞行动画
        var $img = $('.product-part .sp-img-inner img')
        if ($img.length) {
            var flyer = $img[0].cloneNode(true)
            flyer.classList.add('sp_clone')
            $('body').append(flyer)
            
            var imgRect = $img[0].getBoundingClientRect();
            
            $(flyer).css({
                width: $img[0].width + 'px',
                height: $img[0].height + 'px',
                background: '#e7e9ef',
                position: 'fixed',
                top: imgRect.top + 'px',
                left: imgRect.left + 'px',
                'z-index': 9999,
                'border-radius': '50%',
                'object-fit': 'cover'
            })

            let finish = $('.sp-cart')
            
            if (finish.length) {
                var cartRect = finish[0].getBoundingClientRect();
                var endX = cartRect.left + cartRect.width / 2 - 25;
                var endY = cartRect.top + cartRect.height / 2 - 25;
                
                $(flyer).animate({
                    top: endY,
                    left: endX,
                    width: 50,
                    height: 50,
                    opacity: 0.4
                }, 500, 'linear', function () {
                    $(this).animate({
                        width: 0,
                        height: 0,
                        opacity: 0
                    }, 0, function () {
                        $(this).remove()
                    })
                })
            } else {
                setTimeout(function() { $(flyer).remove(); }, 600);
            }
        }
    })

    // ========== 弹窗相关 ==========
    $('.sp-btn-pop').click(function () {
        $('.sp-mask').css('display', 'flex')
        $('.sp-pop').show()
    })

    $('.sp-pop .sp-close-btn, .sp-pop2 .sp-close-btn').click(function () {
        $('.sp-mask').hide()
        $('.sp-pop2').hide()
        $('.sp-pop').hide()
    })

    // ========== 标题文本渐出动画 ==========
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll('span')
        const paragraph = gradually.querySelector('.sp-sub-title')

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    spans.forEach((span, index) => {
                        span.style.animation = `swift-up-fade 0.5s ease forwards`
                        span.style.animationDelay = `${index * 0.1}s`
                        const i = span.querySelector('i')
                        if (i) {
                            i.style.animation = `swift-up-fade 0.5s ease forwards`
                            i.style.animationDelay = `${index * 0.1}s`
                        }
                    })
                    const totalDelay = spans.length * 0.1 + 0.3
                    if (paragraph) {
                        paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
                        paragraph.style.animationDelay = `${totalDelay}s`
                    }
                    observer.unobserve(gradually)
                }
            })
        }, { threshold: 0.3 })
        observer.observe(gradually)
    }

    // ========== Tab 轮播 ==========
    const tabs = $('.sp-tab')
    let currentIndex = 0

    function nextTabFunc() {
        if (tabs.length === 0) return
        const currentTab = tabs[currentIndex]
        currentTab.classList.add('sp-tab-ani')
        setTimeout(() => {
            currentTab.classList.remove('sp-tab-ani')
        }, 2500)
        currentIndex = (currentIndex + 1) % tabs.length
        setTimeout(nextTabFunc, 1500)
    }
    nextTabFunc()

    // ========== Swiper 轮播配置 ==========
    var slideW = 529
    var radius = (slideW * 0.5) / Math.sin(Math.PI / 12)

    if (document.querySelector('#carousel .swiper') && typeof Swiper !== 'undefined') {
        var carouselSwiper = new Swiper('#carousel .swiper', {
            watchSlidesProgress: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            loopedSlides: 3,
            grabCursor: true,
            autoplay: {
                delay: 0,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
            freeMode: true,
            speed: 4000,
            on: {
                progress: function (swiper, progress) {
                    for (let i = 0; i < this.slides.length; i++) {
                        var slide = this.slides.eq(i)
                        var slideProgress = this.slides[i].progress
                        const translateX = slideProgress * (slideW / 2.5 - (Math.cos(slideProgress * (1 / 6) * Math.PI) * slideW * 1.2) / 2.5) + 'px'
                        const rotateY = slideProgress * 30
                        const translateZ = radius - Math.cos(slideProgress * (1 / 6) * Math.PI) * radius - 150 + 'px'
                        slide.transform('translateX(' + translateX + ') translateZ(' + translateZ + ') rotateY(' + rotateY + 'deg)')
                    }
                },
                setTransition: function (swiper, transition) {
                    for (var i = 0; i < this.slides.length; i++) {
                        var slide = this.slides.eq(i)
                        slide.transition(transition)
                    }
                },
            },
        })
    }

    // 初始化
    setTimeout(function() {
        changePrice();
        updateProductNumBadge();
        updatePackCountBadge();  // 初始化角标
    }, 100);
})